'use client';

import { useRouter } from 'next/navigation';
import { Ghost } from 'lucide-react';
import { motion } from 'framer-motion';
import './NotFound.css';
import { SeericButton } from './components/SeericButton/SeericButton';

export default function NotFound() {
  const router = useRouter();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="not-found-container"
    >
      <motion.div
        initial={{ x: -80, opacity: 0 }}
        animate={{ x: 80, opacity: 1 }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "reverse",
            duration: 2.5,
            ease: "easeInOut"
          },
          opacity: { duration: 0.6, delay: 0.2 }
        }}
      >
        <Ghost size={80} className="not-found-ghost" />
      </motion.div>
      <motion.h1
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.5 }}
        className="not-found-title"
      >
        404
      </motion.h1>
      <motion.h2
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        className="not-found-subtitle"
      >
        Oups, page introuvable
      </motion.h2>
      <motion.p
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        className="not-found-description"
      >
        La page que vous cherchez n’existe pas ou a été déplacée.<br />
        Vérifiez l’URL ou revenez à l’accueil.
      </motion.p>
      <SeericButton
        onClick={() => router.push('/')}
        className="p-2"
      >
        Retour à l’accueil
      </SeericButton>
    </motion.div>
  );
}
